<script setup lang="ts">
import {nextTick, onMounted, ref} from 'vue';

const props = defineProps({
  modelValue: {
    type: [String, Number]
  },
  label: String,
  type: {
    type: String,
    default: 'text'
  },
  placeholder: String,
  error: String,
  inputClass: {
    type: String,
    default: 'design'
  },
  autoFocus: {
    type: Boolean,
    default: false
  }
});

const formFocus = ref();

onMounted(() => {
  if (props.autoFocus) {
    nextTick().then(() => {
      formFocus.value.focus();
    });
  }
})

</script>

<template>
  <div>
    <label v-if="label" class="block mb-2 text-subtext">{{ label }}</label>
    <input
      :type="type"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      :class="inputClass"
      :placeholder="placeholder"
      ref="formFocus"
      @blur="$emit('blur')"
    />
    <div class="pt-1 pb-1 text-red-500" v-if="error">{{ error }}</div>
  </div>
</template>


<style scoped>
.design {
  @apply bg-slate-800 border border-transparent focus:border-transparent focus:outline-none text-slate-300 rounded focus:ring-slate-700 focus:border-slate-700 block w-full px-2 py-1.5;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

</style>
